import { SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY } from "./constants";

export const clearNotifyMeWarningForSession = () => {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY);
    // eslint-disable-next-line no-empty
  } catch (_) {}
};
